module.exports = __webpack_public_path__ + "img/Frente-32-02 open.2cd078d3.jpg";